import React from 'react';

/**
 * Container for all Zinnia components.
 *
 * @deprecated Zinnia components are now styled with CSS modules instead of Emotion. This component is no longer necessary and simply renders `children`.
 */
export function ZinniaProvider({
  children,
}: {
  children: React.ReactNode;
  /** If `true`, prepends Emotion style tags in the `head`. Doing so allows CSS module styles to override components' Emotion styles. */
  /** @deprecated Zinnia components are now styled with CSS modules instead of Emotion. This prop has no effect. */
  shouldPrependEmotionStyles?: boolean;
  /** Define an insertion point for the emotion styles. If not provided, the styles will be prepended to the `head`. */
  /** @deprecated Zinnia components are now styled with CSS modules instead of Emotion. This prop has no effect. */
  insertionPoint?: HTMLElement;
}) {
  return children;
}
